'use es6';

import ActionTypes from '../constants/ActionTypes';
var initialState = null;

var trialState = function trialState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case ActionTypes.TRIAL_STATE_RECEIVED:
      return payload;

    case ActionTypes.TRIAL_STATE_REQUESTED:
    case ActionTypes.TRIAL_STATE_FAILED:
      return null;

    default:
      return state;
  }
};

export default trialState;